import { LIGHT_GRAY, WHITE } from '@/scripts/constants/colours'

export const PRODUCT_TILE_MOBILE = { size: 350, color: LIGHT_GRAY }
export const PRODUCT_TILE_DESKTOP = { size: 720, color: LIGHT_GRAY }
export const PRODUCT_TILE_SWATCHES = { size: 400, color: LIGHT_GRAY }

export const PRODUCT_PDP_MOBILE = { size: 350, color: LIGHT_GRAY }
export const PRODUCT_PDP_DESKTOP = { size: 720, color: LIGHT_GRAY }
export const SMALL_IMAGE_WHITE_BACKGROUND = { size: 100, color: WHITE }
export const PRODUCT_PDP_COLOR_CAROUSEL = { size: 200, color: LIGHT_GRAY }
export const PRODUCT_PDP_MOBILE_PRESCRIPTION = { size: 400, color: LIGHT_GRAY }
export const PRODUCT_IMAGE_MINICART = { size: 1000, color: LIGHT_GRAY }

export const IMAGE_FRONT_OLD = '_0000'
export const IMAGE_FRONT_NEW = '_001'

//images with 100% width
export const IMAGE_100_PERCENT_WIDTH = '__om'
